import authAxios from '../common/authAxios';
import Constants from '../common/constants';

const activeTicketService = {
    getAllGrades: () => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/active-tickets`;
        return authAxios.get(url);
    },
    getAllManagerTickets: () => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/manager-tickets`;
        return authAxios.get(url);
    },
    getManagerQueueCount: () => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/manager-queue-count`;
        return authAxios.get(url);
    },
    callNextTicket: () => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/call-next`;
        return authAxios.post(url);
    },
    completeTicket: () => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/complete`;
        return authAxios.post(url);
    },
    repeatCall: () => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/repeat-call`;
        return authAxios.post(url);
    },
    skipTicket: () => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/skip`;
        return authAxios.post(url);
    },
    redirectTicket: (serviceTypeId) => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/redirect`;
        return authAxios.post(url, { serviceTypeId });
    }
};

export default activeTicketService;
